// ========================================
// App Entry Point - Vite + Tailwind + Alpine
// ========================================

// CSS imported via separate entry point in vite.config.js
// import '../css/app.css';

// Import Alpine.js
import Alpine from 'alpinejs';

// Import Axios
import axios from 'axios';

// ========================================
// Global Setup
// ========================================

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const csrfToken = document.querySelector('meta[name="csrf-token"]');
if (csrfToken) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken.content;
}

// ========================================
// Alpine.js Setup
// ========================================

window.Alpine = Alpine;

// Dark mode store
Alpine.store('darkMode', {
    on: localStorage.getItem('darkMode') === 'true',
    toggle() {
        this.on = !this.on;
        localStorage.setItem('darkMode', this.on);
        document.documentElement.classList.toggle('dark', this.on);
    },
    init() {
        document.documentElement.classList.toggle('dark', this.on);
    }
});

// Sidebar store
Alpine.store('sidebar', {
    open: false,
    expanded: localStorage.getItem('sidebarExpanded') !== 'false',
    toggle() {
        this.open = !this.open;
    },
    toggleExpand() {
        this.expanded = !this.expanded;
        localStorage.setItem('sidebarExpanded', this.expanded);
    },
    close() {
        this.open = false;
    }
});

// Notification store
Alpine.store('notifications', {
    count: 0,
    items: [],
    loading: false,
    dropdownOpen: false,
    async fetch() {
        if (this.loading) return;
        this.loading = true;
        try {
            const url = document.querySelector('[data-notifications-url]')?.dataset.notificationsUrl;
            if (!url) return;
            const response = await axios.get(url, {
                params: { unread_only: 1 },
                headers: { 'Accept': 'application/json' }
            });
            if (response.data) {
                this.count = response.data.unread_count || 0;
                this.items = response.data.notifications || [];
            }
        } catch (e) {
            if (e.response?.status === 401) {
                window.location.reload();
            }
        } finally {
            this.loading = false;
        }
    },
    async markAsRead(id, link) {
        try {
            await axios.post(`/notifications/${id}/read`);
            if (link && link !== '#') window.location.href = link;
            else await this.fetch();
        } catch (e) {
            if (link && link !== '#') window.location.href = link;
        }
    },
    async markAllRead() {
        try {
            const url = document.querySelector('[data-mark-all-read-url]')?.dataset.markAllReadUrl;
            if (!url) return;
            await axios.post(url);
            await this.fetch();
        } catch (e) {
            console.debug('Error marking all read:', e);
        }
    }
});

// Start Alpine
Alpine.start();

// ========================================
// Lucide Icons Init (loaded via CDN in layout)
// ========================================

function initLucideIcons() {
    if (window.lucide) {
        window.lucide.createIcons();
    }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    initLucideIcons();
    Alpine.store('darkMode').init();

    // Start notification polling for authenticated users
    const notifEl = document.querySelector('[data-notifications-url]');
    if (notifEl) {
        Alpine.store('notifications').fetch();
        setInterval(() => Alpine.store('notifications').fetch(), 30000);
    }
});

// Re-init Lucide after dynamic content loads (infinite scroll, AJAX)
window.refreshIcons = initLucideIcons;
